import React, { useState, useEffect } from "react"
import MasterGamesList from "../data/MasterGamesList"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { useNavigate } from "react-router-dom"
import { promotionsData } from "../data/PromotionData"

export default function PragmaticPlayDailyTourna() {
  const navigate = useNavigate()
  const data = promotionsData.find(
    (promo) => promo.title === "Super Scatter Daily Tournaments"
  )

  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  //If the promo page is expired - throws error
  useEffect(() => {
    if (!data) {
      navigate("/not-found")
    }
  }, [data, navigate])

  if (!data) return null

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Super Scatter Daily Tournaments</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />
            </div>
            <div className="promotion-tnc-content">
              <div className="promotion-tnc-info">
                <div
                  className={`promotion-indication-message ${data.promotionMessage.class}`}
                >
                  {data.promotionMessage.text}
                </div>
                <h1>Super Scatter Daily Tournaments </h1>
                <h2>Win a share of ₱100M in Daily Tournaments!</h2>
                <div className="promotion-tnc-period">
                  <strong>Promo Period : </strong>
                  <span>October 31, 2025 – November 14, 2025</span>
                </div>
              </div>
              <div className="promotion-tnc-mechanic-content">
                <strong>How does it work : </strong>
                <ol>
                  <li>
                    182,000 winners will win cash prizes worth{" "}
                    <b> ₱104,991,600 </b>
                    October 31 2025, 20:00 to November 14 2025, 00:59 (GMT+8).
                  </li>
                  <li>
                    There are 14 daily tournaments during the promotion period,
                    running daily from 20:00 to 00:59 (GMT+8). Schedule:
                    <ul style={{ marginBottom: "10px" }}>
                      <li>
                        <b>Week 1:</b> 31 Oct – 7 Nov: with 15,000 daily winners
                        and prizes worth up to ₱10,271,800
                      </li>
                      <li>
                        <b>Week 2:</b> 7 – 14 Nov: with 11,000 daily winners and
                        prizes worth up to ₱4,727,000
                      </li>
                    </ul>
                  </li>
                  <li>
                    Winners are based on Largest win from a single spin
                    (adjusted for bet value).
                  </li>
                  <li>
                    Scores = (Largest single win during tournament)/(winning bet
                    during tournament)*100
                    <ul style={{ marginBottom: "10px" }}>
                      Sample computation:
                      <li>
                        Player 1: bet $1 - win $50 (score = $50 / $1 * 100 =
                        5,000)
                      </li>
                      <li>
                        Player 2: bet $1 - win $5 (score = $5 / $1 * 100 = 500)
                      </li>
                    </ul>
                  </li>
                  <li>No minimum bet is required for this promotion.</li>
                  <li>
                    Qualified Game:{" "}
                    <strong className="highlight">
                      Starlight Princess Super Scatter, Fortune Ace Super
                      Scatter, Sweet Bonanza Super Scatter, Gates of Olympus
                      Super Scatter
                    </strong>
                    <MasterGamesList
                      fachaiGamesOnly="on"
                      customWrapperClass="gameListWrapper promotion-signup-game-list"
                      customFaChaiGames={[
                        {
                          provider: "pp",
                          gameName: "Starlight Princess Super Scatter",
                        },
                        {
                          provider: "pp",
                          gameName: "Fortune Ace Super Scatter",
                        },
                        {
                          provider: "pp",
                          gameName: "Sweet Bonanza Super Scatter",
                        },
                        {
                          provider: "pp",
                          gameName: "Gates of Olympus Super Scatter",
                        },
                      ]}
                      rank="off"
                      limit={5}
                      headerText={null}
                      linkTo={null}
                      headerTag="h2"
                    />
                  </li>
                </ol>
                <div className="promotion-tnc-cta">
                  <a
                    href={data.specialLink}
                    className="promotion-cta-btn"
                    target="blank"
                    rel="nofollow"
                  >
                    Full T&C
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
